import React, { useMemo } from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';

import Menu from '../menu/Menu';
import SearchFiles from '../search/SearchFiles';
import Filters from '../filters/Filters';

function FirmDocumentsHeader({ modals, setSelectedItem, setVersionFileUpload, breadCrumbs }) {
  const history = useHistory();

  const isVirtualFolder = useMemo(() => breadCrumbs?.some((file) => file?.is_virtual === true), [breadCrumbs]);

  const handleFirmUpload = () => {
    setSelectedItem();
    setVersionFileUpload(false);
    modals.setIsFirmDocumentsUpload(true);
    modals.setShowFileUploadModal(true);
  };

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between flex-wrap mb-2 gap-2">
        <div className="d-flex">
          <a className="text-decoration-none pointer" onClick={() => history.push('/file-manager')}>
            <div className="icon-box me-3 mt-2">
              <i className="pi pi-angle-left"></i>
            </div>
          </a>
          <div>
            <h1 className="title gray-800 mb-0 fs-3 fs-md-1" style={{ fontSize: '24px', fontWeight: '600' }}>
              Firm Documents
            </h1>
            <div className="d-flex align-items-center mb-1">
              <span className="text-muted me-2 cursor-pointer" style={{ fontSize: '14px' }} onClick={() => history.push('/file-manager')}>
                File Manager
              </span>
              <i className="pi pi-angle-right text-muted me-2" style={{ fontSize: '12px' }}></i>
              <span style={{ fontSize: '14px', fontWeight: '500' }}>Firm Documents</span>
            </div>
          </div>
        </div>
        {!isVirtualFolder && <Button label="Upload to Firm Documents" className="p-button p-button-primary" onClick={handleFirmUpload} />}
      </div>

      <div className="d-flex align-items-center mb-3 justify-content-between flex-wrap">
        <div className="d-flex flex-wrap align-items-center filter-wrap p-2 align-items-center justify-content-between gap-2">
          <SearchFiles />
          <Filters />
        </div>
        <div className="d-flex align-items-center gap-2 my-2">
          <Menu />
        </div>
      </div>
    </div>
  );
}

export default FirmDocumentsHeader;
